import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderCurveComponent } from './header-curve.component';

@NgModule({
  declarations: [HeaderCurveComponent],
  imports: [
    CommonModule
  ],
  exports: [HeaderCurveComponent]
})
export class HeaderCurveModule { }
